import { CompositeDecorator, convertFromRaw, EditorState } from 'draft-js'
import { DraftailEditor } from 'draftail'
import { useEffect, useMemo, useState } from 'react'
import './customStyle.css'
import './listColorStyle.css'
import { ReactTable } from './ReactTable'
import { CustomTable } from './TableViews'
import { BLOCKQUOTE } from './TextEditorConstants'
import { COLORS_INLINE_STYLE, INLINE_CONTROL } from './ui'
const styleMap = {
  CODE: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    width: '100%',
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    lineHeight: 25,
    flexWrap: 'wrap',
  },
  hyperlink: {
    color: '#0070B6',
    textDecoration: 'underline',
  },
}

const Link = (props: any) => {
  const key = props?.entityKey
  const { url } = props.contentState.getEntity(key).getData()
  return (
    <a href={url} style={styleMap.hyperlink} target="_blank">
      {props.children}
    </a>
  )
}

const Table = (props: any) => {
  const { columns, data, colSpans, rowSpans, cssStyle } = props.contentState.getEntity(props.entityKey).getData()
  return <ReactTable columns={columns} data={data} colSpans={colSpans} rowSpans={rowSpans} cssStyle={cssStyle} />
}

export const RichText = (props: any) => {
  const [editorState, updateEeditorState] = useState(null)
  const { initialData } = props

  const decorator = useMemo(() => {
    const findLinkEntities = (contentBlock: any, callback: any, contentState: any) => {
      contentBlock.findEntityRanges((character: any) => {
        const entityKey = character.getEntity()
        return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK'
      }, callback)
    }
    const findTableEntities = (contentBlock: any, callback: any, contentState: any) => {
      contentBlock.findEntityRanges((character: any) => {
        const entityKey = character.getEntity()
        return entityKey !== null && contentState.getEntity(entityKey).getType() === 'TABLE'
      }, callback)
    }
    const findCustomTableEntities = (contentBlock: any, callback: any, contentState: any) => {
      contentBlock.findEntityRanges((character: any) => {
        const entityKey = character.getEntity()
        return entityKey !== null && contentState.getEntity(entityKey).getType() === 'CUSTOMTABLE'
      }, callback)
    }
    return new CompositeDecorator([
      {
        strategy: findLinkEntities,
        component: Link,
      },
      {
        strategy: findTableEntities,
        component: Table,
      },
      {
        strategy: findCustomTableEntities,
        component: CustomTable,
      },
    ])
  }, [])

  useEffect(() => {
    try {
      if (initialData) {
        updateEeditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(initialData)), decorator))
      } else {
        updateEeditorState(EditorState.createEmpty(decorator))
      }
    } catch (error) {
      updateEeditorState(EditorState.createEmpty())
    }
  }, [decorator, initialData])

  //function to get the style for blockquote
  const getBlockStyle = (block: any) => {
    switch (block.getType()) {
      case BLOCKQUOTE:
        return 'RichEditor-blockquote'
      default:
        return null
    }
  }

  if (editorState) {
    return (
      <DraftailEditor
        blockStyleFn={getBlockStyle}
        customStyleMap={styleMap}
        editorState={editorState}
        inlineColorStyleArray={COLORS_INLINE_STYLE}
        readOnly
        topToolbar={''}
        inlineStyles={Object.values(INLINE_CONTROL)}
      />
    )
  }
  return null
}

RichText.defaultProps = {
  initialData: null,
}
